module.exports = __webpack_public_path__ + "img/MAC1680_R.f98f5abc.png";